module.exports = __webpack_public_path__ + "static/media/check.92a15f31.svg";